import { writable } from 'svelte/store';
export const idPageServices = "services";
export const idPageServicesAssainissement = "services-assainissement";
export const idPageServicesBalayage = "services-balayage";
export const idPageServicesContact = "services-contact";
export const idPageAmenagements = "amenagements";
export const idPageAmenagementsEnrobes = "amenagements-enrobes";
export const idPageAmenagementsResines = "amenagements-resines";
export const idPageAmenagementsPavage = "amenagements-pavage";
export const idPageAmenagementsContact = "amenagements-contact";
export const namePageServices = "services";
export const namePageServicesAssainissement = "ASSAINISSEMENT ET RÉSEAUX";
export const namePageServicesBalayage = "BALAYAGE";
export const namePageServicesContact = "CONTACT";
export const namePageAmenagements = "AMÉNAGEMENTS";
export const namePageAmenagementsEnrobes = "ENROBÉS";
export const namePageAmenagementsResines = "RÉSINES DRAINANTES";
export const namePageAmenagementsPavage = "PAVAGE";
export const namePageAmenagementsContact = "CONTACT";
export const storeFirstDisplayHome = writable(true);
